import React from 'react';

import genericSelectors from '../../genericSelectors';

import stableSort from './stableSort';

// Shift and Goal Data
const getShiftData = (data) => {
    return data.filter((event) => {
        return event.typeCode === 517;
    });
};

const getGoalData = (data) => {
    return (
        data
            // filter out goal events
            .filter((event) => {
                return event.typeCode === 505;
            })
            // sort by goal time
            .sort((a, b) => {
                let timeStringToNumber = function (obj) {
                    return parseInt(obj.startTime.replace(/:/g, ''), 10);
                };
                return timeStringToNumber(a) - timeStringToNumber(b);
            })
            // sort by period
            .sort((a, b) => {
                return a.period - b.period;
            })
    );
};

const createHtmlTeamDisplay = (gameId, teamId, teams, className = '', background = 'light') => {
    const team = genericSelectors.getTeam(teams, teamId);
    const seasonId = genericSelectors.getSeasonFromGameId(gameId);

    const logo =
        team?.logos.find((logo) => {
            return logo.startSeason <= seasonId && logo.endSeason >= seasonId && logo.background === background;
        }) ||
        team?.logos
            .sort((a, b) => a.endSeason - b.endSeason)
            .reverse()
            .find((logo) => logo.background === background);
    return `<img src="${logo?.secureUrl}" alt="${team?.fullName}" class="${className}" draggable="false" />`;
};

// Processed Shifts
const utcDateForTimeStringAndPeriod = (timeString, period) => {
    const seconds = parseInt(timeString.split(':')[1], 10);
    const minutes = parseInt(timeString.split(':')[0], 10) + (period - 1) * 20;

    return Date.UTC(0, 0, 0, 0, minutes, seconds);
};

const getPlayerShifts = (shiftData) => {
    return shiftData.reduce((players, player) => {
        const { playerId } = player;
        const playerData = players[playerId] || [];
        playerData.push(player);
        players[playerId] = playerData;
        return players;
    }, {});
};

const shiftDataForPlayers = (players) => {
    return Object.values(players).map((player) => {
        const name = `${player[0].firstName} ${player[0].lastName}`;

        player = stableSort(player, 'period');
        player = stableSort(player, 'shiftNumber');

        const intervals = player.map((shiftData) => {
            const startMinutes = parseInt(shiftData.startTime.split(':')[0], 10) + (shiftData.period - 1) * 20;

            return {
                period: shiftData.period,
                shiftNumber: shiftData.shiftNumber,
                showHourFlag: startMinutes > 60,
                from: utcDateForTimeStringAndPeriod(shiftData.startTime, shiftData.period),
                to: utcDateForTimeStringAndPeriod(shiftData.endTime, shiftData.period),
            };
        });

        return {
            name,
            teamId: player[0].teamId,
            color: player[0].hexValue,
            intervals,
        };
    });
};

const getProcessedShifts = (shifts) => {
    const playerShifts = getPlayerShifts(shifts);
    let processedShifts = shiftDataForPlayers(playerShifts);

    /* We want the data organized in a certain way and the data is an array of objects hence the stack sorts.
     * Read the sorts backwards (i.e. teamId -> period -> shift...) to get a feel for how the data should look like.
     * The stacking order is in reverse because otherwise the data would not be organized into two chunks (one for
     * each team). Stable sorting is used to accomplish this.
     */
    processedShifts = stableSort(processedShifts, 'to', true).reverse();
    processedShifts = stableSort(processedShifts, 'from', true);
    processedShifts = stableSort(processedShifts, 'shiftNumber', true);
    processedShifts = stableSort(processedShifts, 'period', true);
    processedShifts = stableSort(processedShifts, 'teamId');

    return processedShifts;
};

export default {
    createHtmlTeamDisplay,
    getGoalData,
    getProcessedShifts,
    getShiftData,
    utcDateForTimeStringAndPeriod,
};
